import instanceAxios from "./instance";

const instance = instanceAxios();

export default instance;
